// extracted by mini-css-extract-plugin
export default {"root":"Aq8653F03Ft_pj2vdKto","title":"Yb3N7MM4KctWHL4HRrtW","participants":"t40HjWG52XTFK1GB_q32","duration":"jOxaOy7uUrvu5rYO1wBr"};